import React, { useState } from "react";
import ConfettiExplosion from "react-confetti-explosion";

function SecondaryButton({
  warning = false,
  startIcon,
  disabled = false,
  children,
  onClick,
  mobile = false,
  className,
  confetti = false,
  big = false,
}) {
  const [confettiState, setConfettiState] = useState(false);

  const baseClasses =
    "flex items-center font-light text-h3 border-1 min-w-fit w-fit border-grey-100 shadow-md bg-white transition-all duration-200 ease-in-out";
  const mobileClasses = mobile
    ? "px-4 py-1 rounded-full "
    : big
      ? "px-4 py-2 rounded-lg  "
      : "px-3 py-1 rounded-lg ";
  const textColorClasses = warning ? "text-red-600" : "text-gray-500";
  const shadowClasses =
    "shadow-[0px_1px_5px_rgba(0,0,0,0.2)] hover:shadow-[0px_1px_5px_rgba(0,0,0,0.3)]";
  const hoverClasses = "hover:bg-gray-100";
  const disabledClasses = disabled
    ? "opacity-50 cursor-not-allowed"
    : "cursor-pointer";
  const minWidthClass = "min-w-[10px]";

  const buttonClasses = `${baseClasses} ${mobileClasses} ${textColorClasses} ${shadowClasses} ${hoverClasses} ${disabledClasses} ${minWidthClass} ${
    className || ""
  }`;

  return (
    <button
      disabled={disabled}
      className={buttonClasses}
      onClick={(e) => {
        onClick && onClick(e), confetti && setConfettiState(true);
      }}
    >
      <div className="flex flex-row gap-2 items-center">
        {" "}
        {confettiState && <ConfettiExplosion />}
        {startIcon}
        {children}
      </div>
    </button>
  );
}

export default SecondaryButton;
